module.exports = __webpack_public_path__ + "media/images/folder_open-456a504c0cb510e2aaef3ac2186fd2f6.png";